import * as React from 'react';
import { GridFilterCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { useTranslation } from 'react-i18next';
import { GridFilterOperator } from '@progress/kendo-react-grid/dist/es/interfaces/GridFilterOperator';
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

export const inOperator = (value: string, pattern: string): boolean => {
  if (!pattern) return true;
  const parts = pattern.split(',').map((split) => split.trim());
  return parts.includes(value);
};

const numericOperators: GridFilterOperator[] = [
  { text: 'Is in', operator: inOperator },
  { text: 'Contains', operator: 'contains' },
  { text: 'Is equal to', operator: 'eq' },
];

const IdFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const { t, i18n } = useTranslation();

  const onOperatorChange = (e: DropDownListChangeEvent) => {
    const item = e.value as GridFilterCellProps;

    props.onChange({
      value: props.value,
      operator: item.operator ?? '',
      syntheticEvent: e.syntheticEvent,
    });
  };

  const onChange = (event: InputChangeEvent) => {
    props.onChange({
      value: event.value,
      operator: props.operator ?? defaultOperator.operator,
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    props.onChange({
      value: null,
      operator: '',
      syntheticEvent: e,
    });
  };

  const itemRender = (props_: { item: GridFilterOperator; itemIndex: number }) => {
    const { item: operator } = props_;
    const isSelected = operator.operator === props.operator;

    return (
      <div className={isSelected ? 'is-selected k-flex k-items-center' : 'k-flex k-items-center'}>{operator.text}</div>
    );
  };

  const defaultOperator = numericOperators[0];

  return (
    <div className="k-filtercell">
      <div className="k-filtercell-wrapper">
        <Input value={props.value} onChange={onChange} autoComplete="off" />
        <DropDownList
          data={numericOperators}
          textField="text"
          dataItemKey="operator"
          onChange={onOperatorChange}
          value={numericOperators.find((item) => item.operator === props.operator)}
          popupSettings={{ width: '9rem', height: '12rem' }}
          className="k-dropdownlist k-picker k-dropdown-operator k-picker-md k-rounded-md k-picker-solid"
          iconClassName="k-icon k-i-filter k-button-icon"
          style={{ height: '1.875rem', width: '1.875rem' }}
        />
        {/*          <DropDownButton
            items={numericOperators}
            onItemClick={onOperatorChange}
            // Optional: keep height similar to the other controls
            style={{ height: '1.875rem', width: '1.875rem' }}
            svgIcon={filterIcon}
            title={t('Choose Operator')}
            itemRender={itemRender}
            className="k-dropdownlist k-dropdown-operator"
            iconClassName="k-icon k-i-filter k-button-icon"
          />*/}
        <Button
          title={t('Clear')}
          disabled={!props.operator}
          onClick={onClearClick}
          svgIcon={filterClearIcon}
          style={{ height: '1.875rem', width: '1.875rem' }}
        />
      </div>
    </div>
  );
};

export default IdFilterCell;
